import React, { useState } from "react";
import cakeDefault from "../images/cake-close.png";
import cakeHover from "../images/cake-open.png";

const TipButton = () => {
	const [isHovered, setIsHovered] = useState(false);

	return (
		<button
			onClick={() => {
				window.open("https://ko-fi.com/chisel", "_blank", "noopener,noreferrer");
			}}
			onMouseEnter={() => setIsHovered(true)}
			onMouseLeave={() => setIsHovered(false)}
			style={{
				background: "none",
				border: "none",
				cursor: "pointer",
				padding: "0",
				transition: "transform 0.3s ease",
				transform: isHovered ? "scale(1.08)" : "scale(1)",
				gap: "1rem",
			}}
			aria-label="Support with a tip"
		>
			<div
				style={{
					width: "150px",
					height: "150px",
					transition: "filter 0.3s ease",
				}}
			>
				<img
					src={isHovered ? cakeHover : cakeDefault}
					alt="Tip jar"
					style={{
						width: "100%",
						height: "100%",
						objectFit: "contain",
					}}
				/>
			</div>
		</button>
	);
};

export default TipButton;
